export class ToggleShow {
    public static readonly type = '[Loader] show';
}

export class ToggleHide {
    public static readonly type = '[Loader] hide';
}
